import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./planos.component.html')
})
export class PlanosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/planos/planos.component.ts
 **/